// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_35vTphUw","content":"_3huO-F_I","bottomDiv":"J5p78yoc","overlay":"_17ztblqK","imgRow":"_2WIuP3Mz","resultados":"_3WBzjMXb","resultContainer":"_2XD9Iumy","leftCol":"aXjkceHz","rightCol":"_34uCmlVB","paulo":"_38eRIImC","pauloUl":"XnEqUbAQ","pauloImg":"_234cCUHf","results-container":"_2YiAigxz","results-list":"_1iwISjWK"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/Curriculum/Curriculum.styl
// module id = 212
// module chunks = 0